import { cleanDeviceName } from './deviceUtils.js'

export const detectMicrophones = async () => {
    try {
        // Request audio permission to reveal device labels
        await navigator.mediaDevices.getUserMedia({ audio: true })
            .then(stream => {
                stream.getTracks().forEach(track => track.stop())
            })

        const devices = await navigator.mediaDevices.enumerateDevices()

        const allMics = devices
            .filter(device => device.kind === 'audioinput')
            .map(device => {
                const originalLabel = device.label || `Microphone ${device.deviceId.substring(0, 8)}...`
                const cleanLabel = cleanDeviceName(originalLabel)

                return {
                    id: device.deviceId,
                    label: cleanLabel,
                    originalLabel: originalLabel,
                    priority: originalLabel.toLowerCase().includes('communications') ? 1 :
                        originalLabel.toLowerCase().includes('default') ? 2 : 3,
                    deviceType: originalLabel.toLowerCase().includes('communications') ? 'communications' :
                        originalLabel.toLowerCase().includes('default') ? 'default' : 'other'
                }
            })
            .filter(mic => mic.deviceType !== 'other')

        const hasBluetoothMic = allMics.some(mic =>
            /bluetooth|hands[- ]?free|buds|neckband|oppo|boat|realme|airpods|eno|oneplus|sony|jbl/i.test(mic.originalLabel)
        )

        const filteredMics = hasBluetoothMic
            ? allMics
            : allMics.filter(mic => mic.deviceType === 'default')

        return filteredMics.sort((a, b) => a.priority - b.priority)

    } catch (error) {
        console.error('Error detecting microphones:', error)
        return [
            { id: 'default', label: 'Default Microphone', deviceType: 'default' }
        ]
    }
}

export const detectSpeakers = async () => {
    try {
        const devices = await navigator.mediaDevices.enumerateDevices()

        const speakers = devices
            .filter(device => device.kind === 'audiooutput')
            .map(device => {
                const originalLabel = device.label || `Speaker ${device.deviceId.substring(0, 8)}...`
                const cleanLabel = cleanDeviceName(originalLabel)

                return {
                    id: device.deviceId,
                    label: cleanLabel,
                    originalLabel: originalLabel,
                    priority: originalLabel.toLowerCase().includes('communications') ? 1 :
                        originalLabel.toLowerCase().includes('default') ? 2 : 3,
                    deviceType: originalLabel.toLowerCase().includes('communications') ? 'communications' :
                        originalLabel.toLowerCase().includes('default') ? 'default' : 'other'
                }
            })
            .filter(speaker => speaker.deviceType !== 'other')
            .sort((a, b) => a.priority - b.priority)

        return speakers

    } catch (error) {
        console.error('Error detecting speakers:', error)
        return [
            { id: 'default', label: 'Default Speaker', deviceType: 'default' }
        ]
    }
}

export const detectCameras = async () => {
    try {
        await navigator.mediaDevices.getUserMedia({ video: true })
            .then(stream => {
                stream.getTracks().forEach(track => track.stop())
            })

        const devices = await navigator.mediaDevices.enumerateDevices()

        const cameras = devices
            .filter(device => device.kind === 'videoinput')
            .map(device => ({
                id: device.deviceId,
                label: device.label || `Camera ${device.deviceId.substring(0, 8)}...`,
                originalLabel: device.label
            }))

        return cameras

    } catch (error) {
        console.error('Error detecting cameras:', error)
        return [
            { id: 'default', label: 'Default Camera' }
        ]
    }
}